import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    retrieved: null,
    updated: null,
    violations: null,
    brands: [],
    brandsLoading: false,
    languages: [],
    languagesLoading: false,
    translationError: '',
    translation: null,
    translationLoading: false,
    isLoadingGameFileVersion: false,
    gameFileVersionError: '',
    gameFileVersionViolations: null,
    gameFileVersions: [],
    gameFileVersionsView: {},
    gameFileVersionsTotalItems: 0,
    selectedBrandTab: null,
    publishedGameFile: null,
    publishGameFileError: '',
    publishGameFileLoading: false
  },
  actions,
  getters,
  mutations
}
